import Config from "legacy/config";

export function advertiserLabel() {
  if (Config.localization) {
    return Config.localization.advertiserNameFromNetwork.name;
  } else {
    return "Advertiser";
  }
}

export function affiliateLabel() {
  if (Config.localization) {
    return Config.localization.affiliateNameFromNetwork.name;
  } else {
    return "Affiliate";
  }
}
